@if (components && components.length === 0) {
  <div>
    {{ '#UTILITIES.CONTEXT.NO_COMPONENTS' | translate }}
  </div>
}
@for (component of components ?? []; track component) {
  <div class="mt-4">
    <ng-container *ngComponentOutlet="component"></ng-container>
    <soft-ds-separator class="my-2" />
  </div>
}
<div class="flex flex-row justify-end">
  <button
    class="soft-button primary"
    (click)="onSave()"
    [disabled]="loading()"
    >
    @if (loading()) {
      <i class="fa-regular fa-spinner fa-spin"></i>
    }
    {{ '#UTILITIES.CONTEXT.SAVE' | translate }}
  </button>
</div>
